import { render, staticRenderFns } from "./getfree_new.vue?vue&type=template&id=fe4acfb2&scoped=true"
import script from "./getfree_new.vue?vue&type=script&lang=js"
export * from "./getfree_new.vue?vue&type=script&lang=js"
import style0 from "./getfree_new.vue?vue&type=style&index=0&id=fe4acfb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4acfb2",
  null
  
)

export default component.exports